import {
  archivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePost,
  createPatientTagDefinitionPatientTagsDefinitionsPost,
  getIntakePatientTagsPatientTagsIntakesIntakeIdGet,
  getPatientTagsPatientTagsPatientsPatientIdGet,
  listPatientTagDefinitionsPatientTagsDefinitionsGet,
  reactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePost,
  renamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatch,
  replaceIntakePatientTagsPatientTagsIntakesIntakeIdPut,
  replacePatientTagsPatientTagsPatientsPatientIdPut,
} from './api/sdk.gen';
import type {
  PatientTagDefinitionCreate,
  PatientTagDefinitionResponse,
  PatientTagDefinitionUpdate,
  PatientTagReplaceRequest,
  PatientTagResponse,
} from './api/types.gen';

export type {
  PatientTagDefinitionCreate,
  PatientTagDefinitionResponse,
  PatientTagDefinitionUpdate,
  PatientTagReplaceRequest,
  PatientTagResponse,
};

export async function getPatientTagDefinitions(options?: {
  clinicId?: string;
  includeInactive?: boolean;
}): Promise<PatientTagDefinitionResponse[]> {
  const result = await listPatientTagDefinitionsPatientTagsDefinitionsGet({
    query: {
      clinic_id: options?.clinicId,
      include_inactive: options?.includeInactive,
    },
    throwOnError: true,
  });
  return result.data ?? [];
}

export async function createPatientTagDefinition(
  body: PatientTagDefinitionCreate
): Promise<PatientTagDefinitionResponse> {
  const result = await createPatientTagDefinitionPatientTagsDefinitionsPost({
    body,
    throwOnError: true,
  });
  return result.data as PatientTagDefinitionResponse;
}

export async function renamePatientTagDefinition(
  definitionId: string,
  body: PatientTagDefinitionUpdate
): Promise<PatientTagDefinitionResponse> {
  const result =
    await renamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatch({
      path: { definition_id: definitionId },
      body,
      throwOnError: true,
    });
  return result.data as PatientTagDefinitionResponse;
}

export async function archivePatientTagDefinition(
  definitionId: string
): Promise<PatientTagDefinitionResponse> {
  const result =
    await archivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePost(
      { path: { definition_id: definitionId }, throwOnError: true }
    );
  return result.data as PatientTagDefinitionResponse;
}

export async function reactivatePatientTagDefinition(
  definitionId: string
): Promise<PatientTagDefinitionResponse> {
  const result =
    await reactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePost(
      { path: { definition_id: definitionId }, throwOnError: true }
    );
  return result.data as PatientTagDefinitionResponse;
}

export async function getIntakePatientTags(
  intakeId: string
): Promise<PatientTagResponse[]> {
  const result = await getIntakePatientTagsPatientTagsIntakesIntakeIdGet({
    path: { intake_id: intakeId },
    throwOnError: true,
  });
  return result.data ?? [];
}

export async function replaceIntakePatientTags(
  intakeId: string,
  body: PatientTagReplaceRequest
): Promise<PatientTagResponse[]> {
  const result = await replaceIntakePatientTagsPatientTagsIntakesIntakeIdPut({
    path: { intake_id: intakeId },
    body,
    throwOnError: true,
  });
  return result.data ?? [];
}

export async function getPatientTags(
  patientId: string
): Promise<PatientTagResponse[]> {
  const result = await getPatientTagsPatientTagsPatientsPatientIdGet({
    path: { patient_id: patientId },
    throwOnError: true,
  });
  return result.data ?? [];
}

export async function replacePatientTags(
  patientId: string,
  body: PatientTagReplaceRequest
): Promise<PatientTagResponse[]> {
  const result = await replacePatientTagsPatientTagsPatientsPatientIdPut({
    path: { patient_id: patientId },
    body,
    throwOnError: true,
  });
  return result.data ?? [];
}
